import { useCallback, useState } from "react";
import {
  isDeepgramAsrFallbackStatus,
  isDeepgramReconnectingStatus,
} from "./leadAsrListeningUi";

export function useLeadAsrStatus() {
  const [asrStatus, setAsrStatus] = useState("");
  const [isAsrReconnecting, setIsAsrReconnecting] = useState(false);

  const handleAsrStatus = useCallback((status: string) => {
    setAsrStatus(status);
    if (isDeepgramReconnectingStatus(status)) {
      setIsAsrReconnecting(true);
      return;
    }
    if (isDeepgramAsrFallbackStatus(status) || status === "Stopped" || status === "Stopping…") {
      setIsAsrReconnecting(false);
    }
    // "Listening…" / "Connecting…" keep the reconnect pill until the first Results frame.
  }, []);

  /** Dismiss reconnect pill on first inbound transcript chunk after reconnect. */
  const onAsrTranscriptChunk = useCallback(() => {
    setIsAsrReconnecting(false);
  }, []);

  const clearAsrStatusUi = useCallback(() => {
    setAsrStatus("");
    setIsAsrReconnecting(false);
  }, []);

  return {
    asrStatus,
    isAsrReconnecting,
    handleAsrStatus,
    onAsrTranscriptChunk,
    clearAsrStatusUi,
  };
}
